import { ReactNode } from 'react';
import { NavBar } from './Navbar';
import { Footer } from './Footer';

interface ILayoutProps {
  children: ReactNode;
};

/**
 * Component to render app layout
 */

export const Layout = (props: ILayoutProps) => {

  const { children } = props;

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
    }}>
      <div style={{ maxHeight: "80px" }}>
        <NavBar />
      </div>
      <main style={{ flex: 1, marginTop: "80px" }}>
        {children}
      </main>
      <Footer />
    </div>
  );
};